import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import Agents from './domains/agents';

/**
 * Root component of the Agents application.
 * Mounted by the Core Shell under <Route path="agents/*">.
 * Also usable standalone via main.jsx.
 */
const AgentsApp = () => {
  const { ready, t } = useTranslation('agents');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider
      config={{
        position: 'top-right',
        defaultDuration: 4000,
        defaultMaxWidth: '480px',
        defaultMinWidth: '320px',
      }}
    >
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <Agents />
      </div>
    </ToastProvider>
  );
};

export default AgentsApp;
